import { render, staticRenderFns } from "./AutoImportCountdown.vue?vue&type=template&id=28a0ba3b&scoped=true"
import script from "./AutoImportCountdown.vue?vue&type=script&lang=js"
export * from "./AutoImportCountdown.vue?vue&type=script&lang=js"
import style0 from "./AutoImportCountdown.vue?vue&type=style&index=0&id=28a0ba3b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28a0ba3b",
  null
  
)

export default component.exports